import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LocalisedMessage from 'components/Common/LocalisedMessage';

const CollapsibleHeader = ({ isShown, onExpandCollapse, text }) => (
  <button
    aria-expanded={ isShown }
    type="button"
    className="showhide-collapsible-button"
    onClick={ () => { onExpandCollapse(!isShown); } }
  >
    <FontAwesomeIcon icon={ isShown ? 'chevron-up' : 'chevron-down' } className="toggle-arrow" />
    <LocalisedMessage id={ text } />
  </button>);

CollapsibleHeader.propTypes = {
  isShown: PropTypes.bool,
  onExpandCollapse: PropTypes.func.isRequired,
  text: PropTypes.string
};

CollapsibleHeader.defaultProps = {
  isShown: false,
  text: ''
};

export default CollapsibleHeader;
